import { render, staticRenderFns } from "./RenderIndexTable.vue?vue&type=template&id=6d118550&"
import script from "./RenderIndexTable.vue?vue&type=script&lang=js&"
export * from "./RenderIndexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports